@if (form; as form) {
  <div class="row" [formGroup]="form">
    <div class='col-md-3'>
      <div class='form-group' *ngIf='"roadNumber" as controlName'>
        <label [for]='controlName'>
          Numer drogi *
        </label>
        <select
          (change)="roadNumberChange(form.getElement($event).value)"
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'>
          <option value=''>Wybierz</option>
          <option [value]='item?.roadNumber' *ngFor='let item of defaultRoadDict()'>
            {{ item.roadNumber }}
          </option>
        </select>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div [ngClass]="hideStreetControl? 'col-md-5' : 'col-md-4'">
      <div class='form-group' *ngIf='"roadName" as controlName'>
        <label [for]='controlName'>
          Nazwa drogi *
        </label>
        <input
          [readonly]="!!form.get(controlName)?.disabled"
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder="Nazwa drogi"
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    @if (!hideStreetControl) {
      <div class='col-md-5'>
        <div class='form-group' *ngIf='"street" as controlName'>
          <label [for]='controlName'>
            Ulica
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu nazwę ulicy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    }
  </div>
}
